export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14843.52e9e071.jpg";